import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import ThemeContextProvider from './contexts/ThemeContext';
import AppRoutes from './AppRoutes';
import { Box, CssBaseline, Paper, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useSelector } from 'react-redux';
import AppSidebar from './components/appSidebar';
import DashboardCards from './components/DashboardCards';
import './fonts/fonts.css';
import './styles/responsive-admin.css';
import './App.css';
import WSListener from './components/WSlistener';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';


import ScreenRotationIcon from '@mui/icons-material/ScreenRotation';
import { SnackbarProvider } from './contexts/SnackBarContext';
import { PermissionsProvider, usePermissions } from './contexts/PermissionsContext';

const LANDSCAPE_ONLY_ROUTES = ['/punto_cassa'];

function AppContent() {
  const { can } = usePermissions();
  const { t } = useTranslation()
  const location = useLocation();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const tenantType = useSelector((state) => state.auth.tenantType);

  useEffect(() => {
    const tenantTitles = {
      RISTORANTE: 'Ristorante',
      SPA: 'Spa',
      SALE_CONGRESSI: 'Meeting & Congressi',
    };
    document.title = isAuthenticated
      ? tenantTitles[String(tenantType || '').toUpperCase()] || 'RistApp'
      : 'RistApp';
  }, [isAuthenticated, tenantType]);

  const isAdmin = location.pathname.startsWith('/admin_page');
  const isMonitorRoute = location.pathname === '/monitor-eventi';
  const isSpaRoute = location.pathname.startsWith('/spa/');
  const isPublicAuthRoute = location.pathname === '/' || location.pathname === '/login' || location.pathname === '/reset-password' || location.pathname === '/sso';
  const hideSidebar = isPublicAuthRoute || isAdmin || location.pathname === '/stampa_prenotazioni' || isMonitorRoute;
  const hideCards = isPublicAuthRoute || isSpaRoute || location.pathname === '/landing_page' || location.pathname === '/punto_cassa' || isAdmin || location.pathname === '/stampa_prenotazioni' || isMonitorRoute;

  // impedimento schermo verticale
  const isPortrait = useRotation()
  const isLandscapeOnlyRoute = LANDSCAPE_ONLY_ROUTES.some(
    (route) => location.pathname === route || location.pathname.startsWith(`${route}/`)
  );
  const shouldBlockPortrait = isPortrait && isLandscapeOnlyRoute;

  function useRotation() {

    const [isPortrait, setIsPortrait] = useState(window.matchMedia("(orientation: portrait)").matches);

    useEffect(() => {
      const media = window.matchMedia("(orientation: portrait)");
      const handler = (e) => setIsPortrait(e.matches);
      media.addEventListener("change", handler);


      return () => media.removeEventListener("change", handler);
    }, [])

    return isPortrait;
  }
  return (
    <>
      {/* Monta UNA sola connessione globale quando autenticato */}
      {isAuthenticated && <WSListener />}

      {!hideSidebar && (
        <>
          <AppSidebar />
          {(!hideCards && !isPortrait && can('stats:view')) && <DashboardCards />}
        </>
      )}
      {!shouldBlockPortrait &&
        <AppRoutes isAuthenticated={isAuthenticated} />
      }
      {shouldBlockPortrait &&
        <Box margin={10}>
          <Paper sx={{
            height: 400,
            position: 'relative', //top: "20%", bottom: "20%", left: "20%", right: "20%",
            padding: 4,
            alignContent: "center",
            borderRadius: 8,
            textAlign: 'center'

          }}>
            <Typography variant='h4'>{t('horizontalPlease')}</Typography>
            <Box sx={{ my: 6 }} textAlign={'center'}>
              <ScreenRotationIcon sx={{ fontSize: 64, transform: "scaleX(-1)" }} />
            </Box>
          </Paper>
        </Box>

      }
    </>
  );
}

function App() {
  return (
    <ThemeContextProvider>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <SnackbarProvider>
          <Router>
            <PermissionsProvider>
              <AppContent />
            </PermissionsProvider>
          </Router>
        </SnackbarProvider>
      </LocalizationProvider>
    </ThemeContextProvider>
  );
}

export default App;
